"use strict";

exports.__esModule = true;
exports.DisconnectionIcon = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var DisconnectionIcon = exports.DisconnectionIcon = function DisconnectionIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    width: props.width,
    height: props.height,
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#666"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: 33.4,
    cy: 32.4,
    r: 1.1,
    fill: "#9a9da4"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.4 13.3c-4.1 4.1-4.7 10.4-1.6 15.1L8.2 36l3.8 3.8 7.5-7.5c4.7 2.9 11 2.3 15.1-1.6l2.2-2.2-3.8-3.8 6.3-6.3c.5-.5.5-1.4 0-2-.5-.5-1.4-.5-2 0L31 22.7l-5.8-5.8 6.3-6.3c.5-.5.5-1.4 0-2-.5-.5-1.4-.5-2 0l-6.3 6.3-3.8-3.8-2 2.2z",
    fill: "#fff"
  }));
};